import { IconProps } from '@tabler/icons-react-native'
import { Circle, Path, Svg } from 'react-native-svg'

export default function ScannerPerson({
  size = 24,
  color = 'black',
  ...props
}: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M4 18C4 15.2386 5.79086 13 8 13H16C18.2091 13 20 15.2386 20 18V21H4V18Z"
        fill={color}
      />
      <Circle cx={12} cy={8} r={4} fill={color} />
    </Svg>
  )
}
